import gsap from "gsap";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "../../../../../utils/helpers/watchPreferredMotion";

export default class UIButton extends DefaultBlock {
	init() {
		this.DOM = {
			gradient: document.getElementById("ui-button-gradient"),
		};
		this.state = {};

		this.buildOn();
	}

	buildOn() {
		gsap.set(this.block, { autoAlpha: 1 });

		const tl = gsap.timeline({
			paused: true,
		});

		tl.from(this.DOM.gradient, {
			x: -440,
			ease: "power3.out",
			duration: 0.9,
			rotate: "-16deg",
		})
			.to(this.DOM.gradient, {
				opacity: 0,
				duration: 0.1,
			})
			.set(this.DOM.gradient, {
				x: -440,
				opacity: 1,
			});

		watchPreferredMotion(() => {
			this.block.addEventListener("mouseenter", () => {
				tl.restart();
			});
		});
	}
}
